import { render } from "./BlogDetailsRightSidebar.vue?vue&type=template&id=7667cdff&ts=true"
import script from "./BlogDetailsRightSidebar.vue?vue&type=script&lang=ts"
export * from "./BlogDetailsRightSidebar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__